import { Auth } from "components/Form/Form";

const url = '';

export const PaysApi = {
    all: () => {
        return fetch(`${url}/pays`, Auth.options('GET'))
            .then(res => res.json());
    },
}